import { ApiClient } from "@/services/ApiService";
import mime from "mime-types";

export default {
  async getUsersByRole() {
    const response = await ApiClient.get(`Report/user-roles`);
    return response.data;
  },
  async getUserReport(id) {
    const response = await ApiClient.get(`Report/user/${id}`);
    return response.data;
  },
  async getCompanyReport(id) {
    const response = await ApiClient.get(`Report/company/${id}`);
    return response.data;
  },
  async getFilteredResults(model) {
    const response = await ApiClient.post(`Report/filter`, model);
    return response.data;
  },
  async export(model) {
    const response = await ApiClient.post(`Report/export`, model, {
      responseType: "blob"
    });
    const file = {
      data: response.data,
      extension: mime.extension(response.data.type),
      name: response.data.name
    };

    return file;
  }
};
